module.exports = __webpack_public_path__ + "static/whatsapp-icon-bccb9978dee9fc0203731f1e7265bd21.jpeg";